import {edgeServer} from '../api_client/apiClient';

export function getCoaches(){
  return(dispatch)=>{
		edgeServer.get('rest/coaches')
		.then((res)=>{
			dispatch({
				type: "GET_COACHES_FULFILLED",
				payload: res.data.data.coaches
			});
		});
  };
}

export function getChatRooms(){
	return(dispatch)=>{
		edgeServer.get('rest/chatrooms')
		.then((res)=>{
			dispatch({
				type: "GET_CHATROOMS_FULFILLED",
				payload: res.data.data.chatrooms
			});
		});
	};
}

export function postChatRooms(coachId){
	return(dispatch)=>{
		edgeServer.post(`rest/coaches/${coachId}/chatrooms`, {headers:{'Content-Type':'application/json'}})
		.then((res)=>{
			dispatch({
				type: "POST_CHATROOMS_FULFILLED",
				payload: res.data.data
			});
		});
	};
}

export function getChatLogs(chatroomId){
	return(dispatch)=>{
		edgeServer.get(`rest/chatrooms/${chatroomId}/messages`)
		.then((res)=>{
			dispatch({
				type: "GET_CHATS_FULFILLED",
				payload: res.data.data
			})
		})
	}
}

export function postChat(content, chatroomId){
	return(dispatch)=>{
		edgeServer.post(`rest/chatrooms/${chatroomId}/messages`,
			content, {headers:{'Content-Type':'application/json'}}
		).then((res)=>{
			dispatch({
				type: "POST_CHAT_FULFILLED",
				payload: res.data.data.message_id
			})
		})
	}
}

export function updatePushSetting(content, chatroomId){
	return(dispatch)=>{
		edgeServer.put(`rest/chatrooms/${chatroomId}`,
			content, {headers:{'Content-Type':'application/json'}}
		).then((res)=>{
			alert('Push Alarm Setting has been changed.')
			dispatch({
				type: "UPDATE_PUSH_FULFILLED",
				payload: res.data
			})
		}).catch((err)=>{
			console.log(err);
			dispatch({
				type: "UPDATE_PUSH_REJECTED",
				payload: err
			})
		})
	}
}

export function addMessage(message){
  return (dispatch) => {
    dispatch({
      type: "NEW_MESSAGE_ARRIVED",
      payload: message
    })
  }
}

export function addPushAlarm(message){
  return (dispatch) => {
    dispatch({
      type: "NEW_ALARM_ARRIVED",
      payload: message
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/CoachAction.js